import { carbonRequest } from "./api";

const REFERENCE_DATA_PAGE_SIZE = 1000;
const INVALID_REFERENCE_DATA_RESPONSE =
  "Invalid carbon reference data response.";
const TRUNCATED_REFERENCE_DATA_RESPONSE =
  "Carbon reference data response is truncated.";

export const CARBON_REFERENCE_CATALOGUES = [
  ["siteType", "Site type"],
  ["controlRelationship", "Control relationship"],
  ["evidenceSource", "Evidence source"],
  ["contractualInstrument", "Contractual instrument"],
  ["energyType", "Energy type"],
  ["heatSteamFactorSource", "Heat and steam factor source"],
  ["heatSteamSupplyScenario", "Heat and steam supply scenario"],
  ["fuel", "Fuel"],
  ["vehicleCategory", "Vehicle category"],
  ["quantityUnit", "Quantity unit"],
  ["refrigerant", "Refrigerant"],
  ["consolidationApproach", "Consolidation approach"],
  ["sourceCategory", "Source category"],
  ["calculationMethod", "Calculation method"],
  ["warningCode", "Warning code"],
  ["fleetBiofuelBlendFlag", "Fleet biofuel blend flag"],
];

const locale = () => {
  if (typeof navigator === "undefined") return "en";
  return navigator.language && navigator.language.toLowerCase().startsWith("es")
    ? "es"
    : "en";
};

export const localizedReferenceLabel = (label, selectedLocale = locale()) => {
  if (typeof label === "string") return label;
  if (!label) return "";
  return label[selectedLocale] || label.en || label.es || "";
};

const validateReferenceDataResponse = (response) => {
  if (
    !response ||
    typeof response !== "object" ||
    Array.isArray(response) ||
    !Array.isArray(response.data) ||
    !Number.isFinite(response.total) ||
    !Number.isInteger(response.total) ||
    response.total < 0 ||
    response.data.length > response.total
  ) {
    throw new Error(INVALID_REFERENCE_DATA_RESPONSE);
  }

  if (response.data.length !== response.total) {
    throw new Error(TRUNCATED_REFERENCE_DATA_RESPONSE);
  }

  return response;
};

export const fetchCarbonReferenceData = (
  accessToken,
  catalogue,
  { page = 1, perPage = REFERENCE_DATA_PAGE_SIZE, includeRetired = false } = {},
) =>
  carbonRequest(
    accessToken,
    `corporate-carbon/reference-data/${catalogue}?page=${page}&perPage=${perPage}&includeRetired=${includeRetired}`,
  ).then(validateReferenceDataResponse);

export const carbonReferenceChoices = async (
  accessToken,
  catalogue,
  includeRetired = false,
) => {
  const response = await fetchCarbonReferenceData(accessToken, catalogue, {
    includeRetired,
  });
  return response.data.map((reference) => ({
    ...reference,
    id: reference.id,
    name: localizedReferenceLabel(reference.label),
  }));
};

export const fetchCarbonOriginChoices = async (accessToken) => {
  const response = await carbonRequest(
    accessToken,
    "origins?page=1&limit=1000&sort=name,ASC",
  );
  if (
    !response ||
    typeof response !== "object" ||
    Array.isArray(response) ||
    !Array.isArray(response.data) ||
    !Number.isInteger(response.total) ||
    response.total < 0 ||
    response.data.length !== response.total ||
    (response.pageCount !== undefined && response.pageCount !== 1)
  ) {
    throw new Error(
      response?.data?.length < response?.total
        ? TRUNCATED_REFERENCE_DATA_RESPONSE
        : INVALID_REFERENCE_DATA_RESPONSE,
    );
  }
  return response.data.map((origin) => ({
    ...origin,
    id: origin.id,
    name: origin.name,
  }));
};
